import React, { useEffect } from 'react';
import { HeroContent } from './HeroContent';
import { HeroQuotePanel } from './HeroQuotePanel';
import { TrustBar } from './TrustBar';
import { Services } from './Services';
import { Reviews } from './Reviews';
import { Safety } from './Safety';
import { Availability } from './Availability';
import { RepairVsReplace } from './RepairVsReplace';
import { SideRearGlass } from './SideRearGlass';
import { Insurance } from './Insurance';
import { Adas } from './Adas';
import { QuoteProcess } from './QuoteProcess';
import { WhyChoose } from './WhyChoose';
import { ServiceArea } from './ServiceArea';
import { EmergencyAutoGlassFAQ } from '../../components/EmergencyAutoGlassFAQ/EmergencyAutoGlassFAQ';
import { FinalCTA } from './FinalCTA';
import { StickyMobileCTA } from './StickyMobileCTA';
export function EmergencyAutoGlass() {
  useEffect(() => {
    document.title = "Emergency Auto Glass Repair | Kosin's Glass";
  }, []);
  return <main className="w-full min-h-screen bg-white font-sans text-slate-900 pb-20 md:pb-0" data-id="element-853">
      <section className="bg-white pt-8 pb-12 md:pt-12 md:pb-16 px-4 sm:px-6 lg:px-8 border-b border-slate-100" data-id="element-854">
        <div className="max-w-7xl mx-auto" data-id="element-855">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start" data-id="element-856">
            <HeroContent data-id="element-857" />
            <HeroQuotePanel data-id="element-858" />
          </div>
        </div>
      </section>
      <TrustBar data-id="element-859" />
      <Services data-id="element-860" />
      <Reviews data-id="element-861" />
      <Safety data-id="element-862" />
      <Availability data-id="element-863" />
      <RepairVsReplace data-id="element-864" />
      <SideRearGlass data-id="element-865" />
      <Insurance data-id="element-866" />
      <Adas data-id="element-867" />
      <QuoteProcess data-id="element-868" />
      <WhyChoose data-id="element-869" />
      <ServiceArea data-id="element-870" />
      <EmergencyAutoGlassFAQ data-id="element-871" />
      <FinalCTA data-id="element-872" />
      <StickyMobileCTA data-id="element-873" />
    </main>;
}